<p-dialog [(visible)]="showModal" [style]="{width: '100vw',padding:'0 15px',border:'none',maxHeight:'100%'}"
  [modal]="true" [showHeader]="false" [closable]="false" appendTo="body">
  <div *ngIf="model != null">
    <div class="order-header">
      <div class="order-view">
        <div *ngIf="showHeader" class="medium large-text">Order {{model?.number}} <span *ngIf="model?.invoiceId"
            style="float: right"><a (click)="switchMode('invoice')"></a></span>
        </div>
        <div class="order-btn">
          <!-- <a style="float: left; margin-right: 20px;" class="btn btn-secondary orderdetail-btn">Edit</a> -->
          <div class="download-button">
            <a style="float: left; margin-right: 9px;" *ngIf="model?.allowEdit && ((sharedServiceClient.getPermissions('orders_edit') && model?.status!=6) || (sharedServiceClient.getPermissions('completedmoves_edit') && model?.status==6))" class="btn btn-secondary orderdetail-btn" (click)="closeEdit()">Edit</a>
            <span style="float: left; padding-right: 5px;" *ngIf="isDownloadingOrder"><i
              class="fa fa-spinner fa-spin"></i></span>
            <a *ngIf="!isDownloadingOrder" style="float: left;" class="btn btn-primary orderdetail-btn mr-2"
              (click)="downloadOrder()">Download
              Order</a>

            <a *ngIf="isDownloadingOrder" style="float: left;" class="btn btn-primary orderdetail-btn mr-2">Download
              Order</a>
            <ng-container *ngIf="showHeader && model?.invoiceId > 0">
              <!-- &nbsp;
              &nbsp;
              &nbsp; -->
              <a class="btn btn-info orderdetail-btn" *ngIf="model?.allowEdit && ((sharedServiceClient.getPermissions('invoices') && (model?.readyToAuditForOrder==false || model?.readyToAuditForOrder==null || model?.status == 6) ) || (sharedServiceClient.getPermissions('ready_to_audit') && model?.readyToAuditForOrder==true))" (click)="showInvoice()">Show Invoice</a>
            </ng-container>
          </div>
          <div class="close-icon">
            <div style="position: relative" class="link-button">
              <a class="muted7" (click)="close()"><img src="./assets/images/close.svg" class="filter-invert" /></a>
            </div>
          </div>
        </div>
      </div>
      <order-tags [order]="model"></order-tags>
      <div *ngIf="showHeader" class="medium small-text" style="border-bottom: 1px solid #B4B4B4;">
        <!-- {{(!isAdding) ? model?.statusName : ''}} -->
      </div>
      <!-- <div style="border-bottom: 1px solid #B4B4B4; margin-bottom: 10px;"></div> -->
      <!-- <div style="display: inline-block; position: relative; top: 3px; font-size: 1.5em"> </div> -->
      <div class="table-view">

        <table class="detail-table">
          <th id="order-detail-header" class="th-display-none"></th>
          <tbody>
            <tr>
              <td>Status:</td>
              <td> {{(!isAdding) ? model?.statusName : ''}}</td>
              <td class="bold table-style">{{metadata['createdBy']}}</td>
              <td>
                <dynamic-value [type]="'text'" [value]="model.createdByName"></dynamic-value>
              </td>
              <td class="bold">Confirmed Ready (for Pickup) By:</td>
              <td>
                <dynamic-value [type]="'text'" [value]="model.confirmedBy"></dynamic-value>
              </td>
              <!-- <td class="bold table-style">{{metadata['dateCreated']}}</td>
              <td>
                <dynamic-value [type]="'datetime'" [value]="model.createdOn"></dynamic-value>
              </td> -->
              <td class="bold table-style">{{metadata['dispatchedByName']}}</td>
              <td>
                <dynamic-value [type]="'text'" [value]="model.dispatchedByName"></dynamic-value>
              </td>
            </tr>
            <tr>
              <!-- <tr *ngIf="model.status >= 3"> -->
              <!-- <td>{{metadata['dispatchedByName']}}</td>
              <td>
                <dynamic-value [type]="'text'" [value]="model.dispatchedByName"></dynamic-value>
              </td> -->
              <!-- </tr>
              <tr *ngIf="model.status >= 3"> -->
              <td>{{metadata['assignedToName']}}</td>
              <td>
                <dynamic-value [type]="'text'" [value]="model.assignedToName"></dynamic-value>
              </td>
              <td class="bold table-style">{{metadata['dateCreated']}}</td>
              <td>
                <dynamic-value [type]="'datetime'" [value]="model.createdOn"></dynamic-value>
              </td>
              <td class="bold"> Confirmed Ready (for Pickup) On:</td>
              <td>
                <dynamic-value [type]="'datetime'" [value]="model.confirmedByDateTime"></dynamic-value>
              </td>
              <td class="bold table-style">Dispatched On:</td>
              <td>
                <dynamic-value [type]="'text'" [value]="model.dispatchedOn"></dynamic-value>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="order-body">
      <div class="row">
        <div class="col-4 pb-3">
          <div class="cards">
            <div class="medium medium-text" style="padding: 10px">Customer Info</div>
            <div class="border-bottom"></div>
            <div class="cards-items">
              <table class="detail-table">
                <th id="order-detail-customer-info" class="th-display-none"></th>
                <tbody>
                  <tr>
                    <td>{{metadata['customerBusinessName']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model?.customerBusinessName"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['customerBusinessHours']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.customerBusinessHours"></dynamic-value>
                    </td>
                  </tr>
                  <!-- <tr *ngIf="model.customerEmail != null">
                    <td>{{metadata['customerEmail']}}</td>
                    <td>
                      <dynamic-value [type]="'email'" [value]="model.customerEmail"></dynamic-value>
                    </td>
                  </tr> -->
                  <tr>
                  <tr>
                    <td>{{metadata['customerAddress1']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.customerAddress1" display="block"></dynamic-value>
                      <dynamic-value [type]="'text'" [value]="model.customerCity"></dynamic-value>{{(model?.customerCity
                      &&
                      (model?.customerStateCode || model?.customerZip)) ? ', ' : ''}}<dynamic-value [type]="'text'"
                        [value]="model.customerStateCode"></dynamic-value>&nbsp;<dynamic-value [type]="'zip'"
                        [value]="model.customerZip"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['customerPhone']}}</td>
                    <td>
                      <dynamic-value [type]="'phone'" [value]="model.customerPhone"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['contactFirstName']}}</td>
                    <!-- <td *ngIf="model?.privateCustomer == YesNoNA.Yes">
                      <dynamic-value [type]="'text'" [value]="model.customerFirstName"></dynamic-value>&nbsp;
                      <dynamic-value [type]="'text'" [value]="model.customerLastName"></dynamic-value>
                    </td> -->
                    <!-- <td *ngIf="model?.privateCustomer != YesNoNA.Yes"> -->
                    <td>
                      <contacts-detail [model]="model.customerContacts"></contacts-detail>
                    </td>
                    <!-- </td> -->
                  </tr>
                  <tr>
                    <td>{{metadata['contactEmail']}}</td>
                    <td>
                      <dynamic-value *ngIf="!anyCustomerContacts" type="text"></dynamic-value>
                      <div *ngFor="let d of model.customerContacts">
                        <dynamic-value [type]="'email'" [value]="d.email"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <!-- <tr>
                    <td [style.background]="model?.customerDocs !=null &&  !model?.customerDocs?.includes(3) ? 'rgba(250, 250, 0, 0.7)' : null">{{metadata['customerDocs']}}</td>
                    <td [style.background]="model?.customerDocs !=null && !model?.customerDocs?.includes(3)? 'rgba(250, 250, 0, 0.7)' : null">
                     <div *ngIf="!isNewCustomerDocOrder">
                     <dynamic-value [type]="'lookup'" [value]="model.customerDocs" [items]="lookups.yesNoNull">
                      </dynamic-value>
                    </div>
                    <div *ngIf="isNewCustomerDocOrder">
                      <dynamic-value [type]="'lookupMultiSelect'" [value]="model.customerDocs" [items]="lookups.customerDocs">
                      </dynamic-value>
                    </div>
                    </td>
                  </tr> -->
                  <tr *ngIf="isNewCustomerDocOrder && model.customerDocCustomer">
                    <td [style.background]="model?.customerDocCustomer != null && model?.customerDocCustomer?.length > 0 ? 'rgba(250, 250, 0, 0.7)' : null">{{metadata['customerDocCustomer']}}</td>
                    <td [style.background]="model?.customerDocCustomer != null && model?.customerDocCustomer?.length > 0 ? 'rgba(250, 250, 0, 0.7)' : null">
                      <dynamic-value [type]="'lookupMultiSelect'" [value]="model.customerDocCustomer" [items]="lookups.customerDocOptions"></dynamic-value>
                    </td>
                  </tr>
                  <tr *ngIf="isNewCustomerDocOrder && model.customerDocPickup">
                    <td [style.background]="model?.customerDocPickup != null && model?.customerDocPickup?.length > 0 ? 'rgba(250, 250, 0, 0.7)' : null">{{metadata['customerDocPickup']}}</td>
                    <td [style.background]="model?.customerDocPickup != null && model?.customerDocPickup?.length > 0 ? 'rgba(250, 250, 0, 0.7)' : null">
                      <dynamic-value [type]="'lookupMultiSelect'" [value]="model.customerDocPickup" [items]="lookups.customerDocOptions"></dynamic-value>
                    </td>
                  </tr>
                  <tr *ngIf="isNewCustomerDocOrder && model.customerDocDelivery">
                    <td [style.background]="model?.customerDocDelivery != null && model?.customerDocDelivery?.length > 0 ? 'rgba(250, 250, 0, 0.7)' : null">{{metadata['customerDocDelivery']}}</td>
                    <td [style.background]="model?.customerDocDelivery != null && model?.customerDocDelivery?.length > 0 ? 'rgba(250, 250, 0, 0.7)' : null">
                      <dynamic-value [type]="'lookupMultiSelect'" [value]="model.customerDocDelivery" [items]="lookups.customerDocOptions"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['customerDocsSignedDate']}}</td>
                    <td>
                      <dynamic-value [type]="'date'" [value]="model.customerDocsSignedDate"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['segment']}}</td>
                    <td>
                      <div class="table-data">
                        <dynamic-value [type]="'lookup'" [value]="model.segment" [items]="lookups.segment"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['subsegment']}}</td>
                    <td>
                      <div class="table-data">
                        <dynamic-value [type]="'lookup'" [value]="model.subSegment" [items]="model.segment === 6 ? lookups.subsegmentupfitter: lookups.sources"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="isNewHubSpotDealOrderNumber">
                    <td>{{metadata['hubspotDealId']}}</td>
                    <td>
                      <div class="table-data">
                        <dynamic-value [type]="'text'" [value]="model.hubspotDealId"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="isShowPickupPassword && !isTenderOrder">
                    <td>{{metadata['pickupPassword']}}</td>
                    <td>
                      <div class="table-data pickup-password">
                        <dynamic-value [type]="'text'" [value]="model.pickupPassword"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-4 pb-3">
          <div class="cards">
            <div class="medium medium-text" style="padding: 10px">Pickup Info</div>
            <div class="border-bottom"></div>
            <div class="delivery-cards-items">
              <table class="detail-table">
                <th id="order-detail-pickup-info" class="th-display-none"></th>
                <tbody>
                  <div *ngIf="isNewRecordForDateOverhual" class="date-overhaul-record">
                    <tr *ngFor="let customerExpectedPickupDate of customerExpectedPickupDates; let i = index;">
                        <td>{{metadata['customerExpectedPickupDates']}} {{i+1}}</td>
                        <ng-template *ngTemplateOutlet="dateoverhaul; context: { $implicit: customerExpectedPickupDate }"></ng-template>
                    </tr>
                  </div>
                  <tr>
                    <td>{{metadata['customerExpectedPickup']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.customerExpectedPickup"></dynamic-value>
                    </td>
                  </tr>
                  <div *ngIf="isNewRecordForDateOverhual" class="date-overhaul-record">
                    <tr *ngFor="let carrierScheduledPickupDate of carrierScheduledPickupDates; let i = index;">
                        <td>{{metadata['carrierScheduledPickupDates']}} {{i+1}}</td>
                        <ng-template *ngTemplateOutlet="dateoverhaul; context: { $implicit: carrierScheduledPickupDate }"></ng-template>
                    </tr>
                  </div>
                  <tr>
                    <td>{{isNewRecordForDateOverhual ?  metadata['carrierPickupDateNote'] : metadata['scheduledPickup']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.scheduledPickup"></dynamic-value>
                    </td>
                  </tr>
                  <div *ngIf="isNewRecordForDateOverhual" class="date-overhaul-record">
                    <tr *ngFor="let pickupNewETADate of pickupNewETADates; let i = index;">
                        <td>{{metadata['pickupNewETADates']}} {{i+1}}</td>
                        <ng-template *ngTemplateOutlet="dateoverhaul; context: { $implicit: pickupNewETADate }"></ng-template>
                    </tr>
                  </div>
                  <tr>
                    <td>{{metadata['actualPickupDate']}}
                      <div class="table-data">
                        <dynamic-value [type]="'date'" [value]="model.actualPickupDate"></dynamic-value>
                      </div>
                    </td>
                    <td class="order-detail-font">{{metadata['pickupConfirmedBy']}}
                      <div class="table-data">
                        <dynamic-value [type]="'text'" [value]="model.pickupConfirmedBy"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['pickupUpdatedUser']}}
                      <div class="table-data">
                        <dynamic-value [type]="'text'" [value]="model.pickupUpdatedUser"></dynamic-value>
                      </div>
                    </td>
                    <td class="order-detail-font">{{metadata['pickupUpdatedTimedate']}}
                      <div class="table-data">
                        <dynamic-value [type]="'datetime'" [value]="model.pickupUpdatedTimedate"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="model.callback1">
                    <td>{{metadata['callback1date']}}:
                      <div class="table-data">
                       <span class="font-weight-normal"> {{ model.callback1date |  date: 'MM/dd/yyyy' }} </span>
                      </div>
                    </td>
                    <td class="order-detail-font">{{metadata['callback1time_only']}}:
                      <div class="table-data">
                        <span class="font-weight-normal"> {{model.callback1date | date:'mediumTime'}}</span>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="model.callback1">
                    <td>{{metadata['callback1note']}}</td>
                    <td>
                      <dynamic-value [type]="'textarea'" [class]="'callback-readonly-height callback-inputbox'" [value]="model.callback1note"></dynamic-value>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="border-bottom-delivery"></div>
            <div class="cards-items">
              <table class="detail-table">
                <tbody>
                  <tr>
                    <td>{{metadata['pickupBusinessName']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.pickupBusinessName"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['pickupBusinessHours']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.pickupBusinessHours"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['pickupAddress1']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.pickupAddress1" display="block"></dynamic-value>
                      <dynamic-value [type]="'text'" [value]="model.pickupCity"></dynamic-value>{{(model?.pickupCity &&
                      (model?.pickupStateCode || model?.pickupZip)) ? ', ' : ''}} <dynamic-value [type]="'text'"
                        [value]="model.pickupStateCode"></dynamic-value>&nbsp;<dynamic-value [type]="'zip'"
                        [value]="model.pickupZip"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['pickupPhone']}}</td>
                    <td>
                        <dynamic-value [type]="'phone'" [value]="model.pickupPhone"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['pickupNotes']}}</td>
                    <td>
                      <dynamic-value [type]="'textarea'" [value]="model.pickupNotes"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['pickupContacts']}}</td>
                    <td>
                      <contacts-detail [model]="model.pickupContacts"></contacts-detail>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['pickupEmail']}}</td>
                    <td>
                      <div *ngFor="let p of model.pickupContacts">
                        <dynamic-value [type]="'text'" [value]="p.email"></dynamic-value>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>{{metadata['pickupPhones']}}</td>
                    <td>
                      <div *ngFor="let p of pickupPhones">
                        <dynamic-value [type]="'phone'" [value]="p"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <!-- <tr *ngIf="model.status > 1">
                    <td>{{metadata['confirmReadyForPickup']}}</td>
                    <td>
                      <dynamic-value [type]="'lookup'" [value]="model.confirmReadyForPickup"
                        [items]="lookups.yesNoNull">
                      </dynamic-value>
                    </td>
                  </tr> -->
                  <!-- <tr>
                    <td>{{metadata['confirmedBy']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.confirmedBy"></dynamic-value>
                    </td>
                  </tr> -->
                  <!-- <tr>
                    <td>{{metadata['pickupUpdatedTimedate']}}</td>
                    <td>
                      <dynamic-value [type]="'datetime'" [value]="model.pickupUpdatedTimedate"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['pickupUpdatedUser']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.pickupUpdatedUser"></dynamic-value>
                    </td>
                  </tr> -->
                  <!-- <tr>
                    <td>{{metadata['confirmedByDateTime']}}</td>
                    <td>
                      <dynamic-value [type]="'datetime'" [value]="model.confirmedByDateTime"></dynamic-value>
                    </td>
                  </tr> -->
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-4 pb-3">
          <div class="cards">
            <div class="medium medium-text" style="padding: 10px">Dispatch Info</div>
            <div class="border-bottom"></div>
            <div class="cards-items">
              <table class="detail-table">
                <th id="order-detail-dispatch-info" class="th-display-none"></th>
                <tbody>
                  <tr *ngIf="isNewBookedOrderNumber">
                    <td>{{metadata['whoBooked']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.whoBookedName"></dynamic-value>
                    </td>
                  </tr>
                  <tr *ngIf="isNewBookedOrderNumber">
                    <td>{{metadata['bookedBy']}}</td>
                    <td>
                      <dynamic-value [type]="'lookup'" [value]="model.bookedBy" [items]="lookups.bookedBy"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['assignedCarrierName']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.assignedCarrierName"></dynamic-value>
                    </td>
                  </tr>
                   <tr>
                    <td>{{metadata['communicationPreferences']}}</td>
                    <td>
                      <dynamic-value [type]="'textarea'" [value]="model.communicationPreferences"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['carrierPhone']}}</td>
                    <td>
                      <dynamic-value [type]="'phone'" [value]="model.carrierBusinessPhone"></dynamic-value>
                      <div *ngFor="let p of carrierPhones">
                        <dynamic-value [type]="'phone'" [value]="p"></dynamic-value>
                      </div>
                      <div *ngIf="model.carrierPhone != null">
                        <dynamic-value [type]="'phone'" [value]="model.carrierPhone"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['dispatcherName']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.dispatcherName"></dynamic-value>
                      {{(model?.dispatcherPhone) ? ', ' : ''}} <dynamic-value [type]="'phone'"
                        [value]="model.dispatcherPhone"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['dispatcherEmail']}}</td>
                    <td>
                      <dynamic-value [type]="'email'" [value]="model.dispatcherEmail"></dynamic-value>
                    </td>
                  </tr>
                  <tr *ngIf="!isNewRecordForTruckOverhual">
                    <td>{{metadata['driverName']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.driverName"></dynamic-value>{{(model?.driverPhone) ?  ',' : ''}} <dynamic-value [type]="'phone'" [value]="model.driverPhone"></dynamic-value>
                    </td>
                  </tr>
                  <tr *ngIf="isNewRecordForTruckOverhual">
                    <td>{{metadata['driverName']}}</td>
                    <td *ngFor="let d of driverNames; let i = index" style="display:block;padding:0;">
                      <div>
                        <dynamic-value [type]="'text'" [value]="d"></dynamic-value>
                        <ng-container *ngIf="i < driverPhones.length">{{', '}}
                          <dynamic-value [type]="'text'" [value]="driverPhones[i]"></dynamic-value>
                        </ng-container>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{{'Trailer Size:'}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.trailerSize"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{'Cargo/Liability Limits:'}}</td>
                    <td class="py-0"> 
                      <div class="cargo-limit-multiple-policy">
                        <ng-container *ngIf="model.carrierPolicyDetail && model.carrierPolicyDetail.length > 0; else noPolicy"
                          class="cargo-policy-container">
                          <div *ngFor="let policy of model.carrierPolicyDetail" class="cargo-policy-container">
                            <div *ngFor="let cargo of policy.cargoLimit">
                              {{ formatCurrency(cargo.cargoInsuranceLimit) }} ;
                              {{ cargo.cargoInsuranceDeductible ? formatCurrency(cargo.cargoInsuranceDeductible) : '--' }}
                            </div>
                            <div *ngFor="let liability of policy.liabilityLimit">
                              {{ formatCurrency(liability.liabilityLimit) }}
                            </div>
                          </div>
                        </ng-container>
                      </div>
                      <ng-template #noPolicy>--</ng-template>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['priceToCarrier']}}</td>
                    <td>
                      <dynamic-value [type]="'currency'" [value]="model.priceToCarrier"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['paymentTerms']}}</td>
                    <td *ngIf="!isPaymentTermsReadOnly">
                      <dynamic-value [type]="'lookup'" [value]="model.paymentTerms" [items]="lookups.paymentTerms">
                      </dynamic-value>
                    </td>
                    <td *ngIf="isPaymentTermsReadOnly">
                      N/A
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['priceToCarrierAdjusted']}}</td>
                    <td>
                      <dynamic-value [type]="'currency'" [value]="model.priceToCarrierAdjusted"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['brokerFeePaid']}}</td>
                    <td>
                      <dynamic-value [type]="'lookup'" [value]="model.brokerFeePaid" [items]="lookups.yesNoNa">
                      </dynamic-value>
                    </td>
                  </tr>
                  <tr *ngIf="model.status >= 2">
                    <td>{{model.brokerFeePaid == 2 ? metadata['brokerFeePrepaidAmount'] :  metadata['brokerFee'] }}</td>
                    <td>
                      <dynamic-value [type]="'currency'" [value]="model.brokerFee"></dynamic-value>
                    </td>
                  </tr>
                  <tr *ngIf="model.brokerFeePaid == 2">
                    <td>{{metadata['brokerFeePaidDate']}}</td>
                    <td>
                      {{model.brokerFeePaidDate}}
                    </td>
                  </tr>
                  <tr *ngIf="model.brokerFeePaid == 2">
                    <td>{{metadata['brokerFeePaymentMethod']}}</td>
                    <td>
                      <dynamic-value [type]="'lookup'" [value]="model.brokerFeePaymentMethod"
                        [items]="lookups['paymentMethod']"></dynamic-value>
                    </td>
                  </tr>
                  <tr *ngIf="model.status > 1">
                    <td>Download documents:</td>
                    <td>
                      <a *ngIf="!isDownloadingCarrierTerms" style="float: left;" class="link-button"
                      (click)="downloadCarrierTerms()">Download Carrier Terms</a>
                    <a *ngIf="isDownloadingCarrierTerms" style="float: left; color: #444 !important;"
                      class="link-button">Download Carrier Terms</a>
                    <span style="float: left; padding-left: 5px;" *ngIf="isDownloadingCarrierTerms"><i
                        class="fa fa-spinner fa-spin"></i></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-4 pb-3">
          <div class="cards">
            <div class="medium medium-text" style="padding: 10px">Order Info</div>
            <div class="border-bottom"></div>
            <div class="cards-items">
              <table class="detail-table table-four-col">
                <th id="order-detail-order-info" class="th-display-none"></th>
                <tbody>
                  <tr>
                    <td [style.background]="model.rush ? 'rgba(250, 250, 0, 0.7)' : null">{{metadata['rush']}}
                      <div class="table-data" [style.background]="model.rush ? 'rgba(250, 250, 0, 0.7)' : null">
                        <dynamic-value [type]="'boolean'" [value]="model.rush"></dynamic-value>
                      </div>
                    </td>
                    <td class="order-detail-font text-center" [style.background]="model.vip ? 'rgba(250, 250, 0, 0.7)' : null">{{metadata['vip']}}
                      <div class="table-data" [style.background]="model.vip ? 'rgba(250, 250, 0, 0.7)' : null">
                        <dynamic-value [type]="'boolean'" [value]="model.vip"></dynamic-value>
                      </div>
                    </td>
                    <td class="order-detail-font w-25">{{metadata['payDrop']}}
                      <div class="table-data">
                        <dynamic-value [type]="'lookup'" [value]="model.payDrop" [items]="lookups.yesNoNull">
                        </dynamic-value>
                      </div>
                    </td>
                    <td class="order-detail-font">{{metadata['perVehicleDollarAmount']}}
                      <div class="table-data">
                        <dynamic-value [type]="'currency'" [value]="model.perVehicleDollarAmount"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4">{{metadata['payDropReason']}}
                      <div class="table-data">
                        <dynamic-value [type]="'text'" [value]="model.payDropReason">
                        </dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4">{{metadata['reviewRequired']}}
                      <div class="table-data">
                        <dynamic-value [type]="'lookup'" [value]="model.reviewRequired" [items]="lookups.reviewRequested">
                        </dynamic-value>
                      </div>
                    </td>
                    <!-- <td class="order-detail-font" colspan="2">{{metadata['source']}}
                      <div class="table-data">
                        <dynamic-value [type]="'lookup'" [value]="model.source" [items]="lookups.sources"></dynamic-value>
                      </div>
                    </td> -->
                  </tr>
                  <tr [style.background]="model?.depositRequired !=null &&  model?.depositRequired==2 ? 'rgba(250, 250, 0, 0.7)' : null">
                    <td colspan="4">{{metadata['depositRequired']}}
                      <div class="table-data">
                        <dynamic-value [type]="'lookup'" [value]="model.depositRequired"
                          [items]="lookups.yesNoNa">
                        </dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4">{{metadata['isDocumentationNecessary']}}
                      <div class="table-data">
                        <dynamic-value [type]="'lookup'" [value]="model.isDocumentationNecessary"
                          [items]="lookups.yesNoNa">
                        </dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4">Documents:
                      <uploads [orderId]="model?.id" [orderGuid]="model?.guid" [showAdd]="false" [isOrderDoc]="true" [showDelete]="false"></uploads>
                    </td>

                  </tr>
                  <tr>
                    <td colspan="4"><span>{{metadata['specialInstructions']}} </span>
                      <span class="table-data" style="white-space: pre-wrap; font-weight: normal;">
                        <ng-container *ngIf="parsedSpecialInstructions.length > 0">
                          <span *ngFor="let part of parsedSpecialInstructions" 
                                [ngClass]="{'pickup-password': part.isPickupPassword}">{{part.text}}</span>
                        </ng-container>
                        <span *ngIf="parsedSpecialInstructions.length === 0">{{model.specialInstructions}}</span>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-4 pb-3">
          <div class="cards">
            <div class="medium medium-text" style="padding: 10px">Delivery Info</div>
            <div class="border-bottom"></div>
            <div class="delivery-cards-items">
              <table class="detail-table">
                <th id="order-detail-delivery-info" class="th-display-none"></th>
                <tbody>
                  <div *ngIf="isNewRecordForDateOverhual" class="date-overhaul-record">
                    <tr *ngFor="let customerExpectedDeliveryDate of customerExpectedDeliveryDates; let i = index;">
                        <td>{{metadata['customerExpectedDeliveryDates']}} {{i+1}}</td>
                        <ng-template *ngTemplateOutlet="dateoverhaul; context: { $implicit: customerExpectedDeliveryDate }"></ng-template>
                    </tr>
                  </div>
                  <tr>
                    <td>{{metadata['customerExpectedDelivery']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.customerExpectedDelivery"></dynamic-value>
                    </td>
                  </tr>
                  <div *ngIf="isNewRecordForDateOverhual" class="date-overhaul-record">
                    <tr *ngFor="let carrierScheduledDeliveryDate of carrierScheduledDeliveryDates; let i = index;">
                        <td>{{metadata['carrierScheduledDeliveryDates']}} {{i+1}}</td>
                        <ng-template *ngTemplateOutlet="dateoverhaul; context: { $implicit: carrierScheduledDeliveryDate }"></ng-template>
                    </tr>
                  </div>
                  <tr>
                    <td>{{isNewRecordForDateOverhual ?  metadata['carrierDeliveryDateNote'] : metadata['scheduledDelivery']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.scheduledDelivery"></dynamic-value>
                    </td>
                  </tr>
                  <div *ngIf="isNewRecordForDateOverhual" class="date-overhaul-record">
                    <tr *ngFor="let deliveryNewETADate of deliveryNewETADates; let i = index;">
                        <td>{{metadata['deliveryNewETADates']}} {{i+1}}</td>
                        <ng-template *ngTemplateOutlet="dateoverhaul; context: { $implicit: deliveryNewETADate }"></ng-template>
                    </tr>
                  </div>
                  <tr>
                    <td>{{metadata['actualDeliveryDate']}}
                      <div class="table-data">
                        <dynamic-value [type]="'date'" [value]="model.actualDeliveryDate"></dynamic-value>
                      </div>
                    </td>
                    <td class="order-detail-font">{{metadata['deliveryConfirmedBy']}}
                      <div class="table-data">
                        <dynamic-value [type]="'text'" [value]="model.deliveryConfirmedBy"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="order-detail-font">{{metadata['deliveryUpdatedUser']}}

                      <div class="table-data">

                        <dynamic-value [type]="'text'" [value]="model.deliveryUpdatedUser"></dynamic-value>

                      </div>

                    </td>
                    <td class="order-detail-font">{{metadata['deliveryUpdatedTimedate']}}

                      <div class="table-data">

                        <dynamic-value [type]="'datetime'" [value]="model.isCanceled ? null : model.deliveryUpdatedTimedate"></dynamic-value>

                      </div>

                    </td>

                  </tr>
                  <tr *ngIf="model.callback2">
                    <td>{{metadata['callback2date']}}:
                      <div class="table-data">
                       <span class="font-weight-normal"> {{ model.callback2date |  date: 'MM/dd/yyyy' }} </span>
                      </div>
                    </td>
                    <td class="order-detail-font">{{metadata['callback2time_only']}}:
                      <div class="table-data">
                        <span class="font-weight-normal"> {{model.callback2date | date:'mediumTime'}}</span>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="model.callback2">
                    <td>{{metadata['callback2note']}}</td>
                    <td>
                      <dynamic-value [type]="'textarea'" [class]="'callback-readonly-height callback-inputbox'" [value]="model.callback2note"></dynamic-value>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="border-bottom-delivery"></div>
            <div class="cards-items">
              <table class="detail-table">
                <tbody>
                  <!-- <tr>
                    <td>{{metadata['isPrivateCustomerAtDelivery']}}</td>
                    <td>
                      <dynamic-value [type]="'lookup'" [value]="model.isPrivateCustomerAtDelivery"
                        [items]="lookups.yesNoNa">
                      </dynamic-value>
                    </td>
                  </tr> -->
                  <tr>
                    <td>{{metadata['deliveryBusinessName']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.deliveryBusinessName"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['deliveryBusinessHours']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.deliveryBusinessHours"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['deliveryAddress1']}}</td>
                    <td>
                      <dynamic-value [type]="'text'" [value]="model.deliveryAddress1" display="block"></dynamic-value>
                      <dynamic-value [type]="'text'" [value]="model.deliveryCity"></dynamic-value>{{(model?.deliveryCity
                      &&
                      (model?.deliveryStateCode || model?.deliveryZip)) ? ', ' : ''}}<dynamic-value [type]="'text'"
                        [value]="model.deliveryStateCode"></dynamic-value>&nbsp;<dynamic-value [type]="'zip'"
                        [value]="model.deliveryZip"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['deliveryPhone']}}</td>
                    <td>
                      <dynamic-value [type]="'phone'" [value]="model.deliveryPhone"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['deliveryNotes']}}</td>
                    <td>
                      <dynamic-value [type]="'textarea'" [value]="model.deliveryNotes"></dynamic-value>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['deliveryContacts']}}</td>
                    <td>
                      <contacts-detail [model]="model.deliveryContacts"></contacts-detail>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['deliveryEmail']}}</td>
                    <td>
                      <div *ngFor="let d of model.deliveryContacts">
                        <dynamic-value [type]="'text'" [value]="d.email"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['deliveryPhones']}}</td>
                    <td>
                      <div *ngFor="let p of deliveryPhones">
                        <dynamic-value [type]="'phone'" [value]="p"></dynamic-value>
                      </div>
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-4 pb-3">
          <div class="cards">
            <div class="medium medium-text" style="padding: 10px">Billing Info</div>
            <div class="border-bottom"></div>
            <div class="cards-items">
              <table class="detail-table">
                <th id="order-detail-billing-info" class="th-display-none"></th>
                <tbody>
                  <tr>
                    <td>{{metadata['customerChargedType']}} <dynamic-value [type]="'lookup'" [value]="model?.customerChargedType"
                        [items]="lookups.customerChargedType"></dynamic-value>
                    </td>
                    <td class="order-detail-font">{{metadata['carrierPaymentType']}}
                      <div class="table-data">
                        <dynamic-value [type]="'lookup'" [value]="model.carrierPaymentType"
                          [items]="lookups.viewcarrierpaymenttype"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['price']}}
                      <div class="table-data">
                        <dynamic-value [type]="'currency'" [value]="model.price"></dynamic-value>
                      </div>
                    </td>
                    <td class="order-detail-font">
                      <span [style.background]="model.desiredProfit ? 'rgba(250, 250, 0, 0.7)' : null">{{metadata['desiredProfit']}} </span>
                      <div class="table-data" [style.background]="model.desiredProfit ? 'rgba(250, 250, 0, 0.7)' : null">
                        <dynamic-value [type]="'text'" [value]="model.desiredProfit">
                        </dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="order-detail-font">{{metadata['deposit']}}
                      <div class="table-data">
                        <dynamic-value [type]="'currency'" [value]="model.deposit">
                        </dynamic-value>
                      </div>
                    </td>
                    <td class="order-detail-font">{{metadata['companyProfit']}}
                      <div class="table-data">
                        <dynamic-value [type]="'currency'" [value]="model.companyProfit">
                        </dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['balanceDue']}}
                      <div class="table-data">
                        <dynamic-value [type]="'currency'" [value]="model.balanceDue">
                        </dynamic-value>
                      </div>
                    </td>
                    <td class="order-detail-font">{{metadata['depositPaymentDate']}}
                      <div class="table-data">
                        <dynamic-value [type]="'date'" [value]="model.depositPaymentDate"></dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="order-detail-font">{{metadata['poNumber']}}
                      <div class="table-data">
                        <dynamic-value [type]="'text'" [value]="model.poNumber">
                        </dynamic-value>
                      </div>
                    </td>
                    <td class="order-detail-font">{{metadata['depositBy']}}
                      <div class="table-data">
                        <dynamic-value [type]="'lookup'" [value]="model.depositBy" [items]="lookups.paymentMethodDepositBy">
                        </dynamic-value>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{{metadata['paymentNotes']}}
                      <div class="table-data">
                        <dynamic-value [type]="'text'" [value]="model.paymentNotes">
                        </dynamic-value>
                      </div>
                    </td>
                    <td class="order-detail-font">
                      <span [style.background]="model?.additionalCost == 2 ? 'rgba(250, 250, 0, 0.7)' : null">{{metadata['additionalCost']}}: </span>
                      <div class="table-data" [style.background]="model?.additionalCost == 2 ? 'rgba(250, 250, 0, 0.7)' : null">
                        <dynamic-value [type]="'lookup'" [value]="model.additionalCost || 3" [items]="lookups.yesNoOnly">
                        </dynamic-value>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-4 pb-3">
          <div class="cards">
            <div class="medium medium-text" style="padding: 10px">Order Notes</div>
            <div class="border-bottom"></div>
            <div class="cards-items">
              <table class="detail-table">
                <th id="order-detail-order-notes" class="th-display-none"></th>
                <tbody>
                  <tr>
                    <td colspan="2">
                      <notes-detail [entityName]="'order'" [entityId]="model.id" [showAdd]="false" [notesOnly]="true">
                      </notes-detail>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-4 pb-3">
          <div class="cards">
            <div class="medium medium-text" style="padding: 10px">New ETA Notes</div>
            <div class="border-bottom"></div>
            <div class="cards-items">
              <notes-detail [entityName]="'order'" [entityId]="model.id" [showAdd]="false" [notesOnly]="true" [isNewETANotes]="true">
              </notes-detail>
            </div>
          </div>
        </div>
        <div class="col-4 pb-3">
          <div class="cards vehicles-detail" *ngIf="showVehicles">
            <vehicles-detail [model]="model.vehicles" [openEnclosed]="model.openEnclosed"></vehicles-detail>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
<ng-template #dateoverhaul let-data>
  <td class="date-overhaul-spacing">
    <ng-container *ngIf="data.startDate; else dash">
      <dynamic-value [type]="'date'" [value]="data.startDate"></dynamic-value>
    </ng-container>
    <ng-template #dash>
     <span class="td-dynamic-data">
       —
     </span>
    </ng-template>
    <span *ngIf="data.dateType == 2"> -
      <ng-container *ngIf="data.endDate; else dash">
        <dynamic-value [type]="'date'" [value]="data.endDate"></dynamic-value>
      </ng-container>
      <ng-template #dash>
       <span class="td-dynamic-data">
         —
       </span>
      </ng-template>
    </span>
  </td>
</ng-template>

